//子级router-view承载
import Center from '@/components/common/center'

//入库管理
import zhongzhuanbuhuo_in_list from '@/pages/zhongzhuanbuhuo/in/list'
//入库预报
import zhongzhuanbuhuo_in_forecast from '@/pages/zhongzhuanbuhuo/in/forecast'
import zhongzhuanbuhuo_in_import from '@/pages/zhongzhuanbuhuo/in/import'

//库存sku
import zhongzhuanbuhuo_stock_list from '@/pages/zhongzhuanbuhuo/stock/list'

import zhongzhuanbuhuo_in_sku_udpate from '@/pages/zhongzhuanbuhuo/in/update.sku'

//待出库
import zhongzhuanbuhuo_wait_out from '@/pages/zhongzhuanbuhuo/stock/wait.out'
//导入出库单
import zhongzhuanbuhuo_sku_import from '@/pages/zhongzhuanbuhuo/stock/sku.import'
//库房管理---出库管理
import zhongzhuanbuhuo_out from '@/pages/zhongzhuanbuhuo/out/list'
//导入出库单
import zhongzhuanbuhuo_out_import from '@/pages/zhongzhuanbuhuo/out/import'
//打印网页
import zhongzhuanbuhuo_out_print from '@/pages/zhongzhuanbuhuo/out/print.page'
//上传快递单
import zhongzhuanbuhuo_out_upload from '@/pages/zhongzhuanbuhuo/out/upload.express'


//废弃管理
import zhongzhuanbuhuo_discard_list from '@/pages/zhongzhuanbuhuo/discard/list'
//废弃单导入
import zhongzhuanbuhuo_discard_import from '@/pages/zhongzhuanbuhuo/discard/import'

export default [{
  path: '/zhongzhuanbuhuo',
  component: Center,
  redirect: '/zhongzhuanbuhuo/in',
  meta: {
    title: 'zhongzhuanbuhuo'
  },
  children: [{
    path: '/zhongzhuanbuhuo/in',
    component: Center,
    redirect: '/zhongzhuanbuhuo/in',
    meta: {
      title: "入库包裹"
    },
    children: [{
      path: '/zhongzhuanbuhuo/in',
      component: zhongzhuanbuhuo_in_list,
      meta: {
        title: "到库包裹"
      },
    },{
      path: '/zhongzhuanbuhuo/in/forecast',
      component: zhongzhuanbuhuo_in_forecast,
      meta: {
        title: "入库预报"
      },
    },{
      path: '/zhongzhuanbuhuo/in/import',
      component: zhongzhuanbuhuo_in_import,
      meta: {
        title: "导入补全"
      },
    },{
      path: '/zhongzhuanbuhuo/in/sku/update',
      component: zhongzhuanbuhuo_in_sku_udpate,
      meta: {
        title: "更新包裹内含物"
      },
    }]
  }, {
    path: '/zhongzhuanbuhuo/stock',
    component: Center,
    redirect: '/zhongzhuanbuhuo/stock',
    meta: {
      title: "库存SKU"
    },
    children: [{
      path: '/zhongzhuanbuhuo/stock',
      component: zhongzhuanbuhuo_stock_list,
      meta: {
        title: "库存SKU"
      },
    }]
  }, {
    path: '/zhongzhuanbuhuo/out',
    component: Center,
    redirect: '/zhongzhuanbuhuo/out',
    meta: {
      title: "出库单"
    },
    children: [{
      path: '/zhongzhuanbuhuo/out',
      component: zhongzhuanbuhuo_out,
      meta: {
        title: "出库单"
      },
    }, {
      path: '/zhongzhuanbuhuo/out/import',
      component: zhongzhuanbuhuo_out_import,
      meta: {
        title: "导入出库单"
      },
    }, {
      path: '/zhongzhuanbuhuo/wait/out',
      component: zhongzhuanbuhuo_wait_out,
      meta: {
        title: "待出库区"
      },
    }, {
      path: '/zhongzhuanbuhuo/out/upload',
      component: zhongzhuanbuhuo_out_upload,
      meta: {
        title: "上传Label"
      },
    }, {
      path: '/zhongzhuanbuhuo/out/print',
      component: zhongzhuanbuhuo_out_print,
      meta: {
        title: '打印'
      },
    }]
  }, {
    path: '/zhongzhuanbuhuo/discard',
    component: Center,
    redirect: '/zhongzhuanbuhuo/discard',
    meta: {
      title: "废弃单"
    },
    children: [{

      path: '/zhongzhuanbuhuo/discard',
      component: zhongzhuanbuhuo_discard_list,
      meta: {
        title: "废弃单"
      },
    }, {
      path: '/zhongzhuanbuhuo/discard/import',
      component: zhongzhuanbuhuo_discard_import,
      meta: {
        title: "导入废弃单"
      },
    }]
  }]
}]



// WEBPACK FOOTER //
// ./src/router/module/zhongzhuanbuhuo.js